import { useMemo } from "react"
import type { Stock } from "@stockline/shared/types/inventory/stock"
import { STOCK_TABLE } from "../../../lib/offline/resources/inventory/stock/db"
import { useAISync } from "../../ai/providers/AISyncProvider"

export interface UseStocksFilter {
  productId?: string
  partnerId?: string
  lotId?: string
  locationId?: string
  /**
   * If true, include soft-deleted rows. Defaults to false — tombstones must
   * be hidden so the SSE delete + delta-pull upsert (with `deletedAt` set)
   * removes the row from the list rather than re-rendering it as a zombie.
   */
  includeDeleted?: boolean
}

export function useStocks(filter?: UseStocksFilter): Stock[] {
  const { reactive } = useAISync()
  const rows = reactive.useQuery<Stock>(STOCK_TABLE, {
    ...(filter?.productId ? { productId: filter.productId } : {}),
    ...(filter?.partnerId ? { partnerId: filter.partnerId } : {}),
    ...(filter?.lotId ? { lotId: filter.lotId } : {}),
    ...(filter?.locationId ? { locationId: filter.locationId } : {}),
    orderBy: "createdAt",
  })
  const includeDeleted = filter?.includeDeleted
  return useMemo(
    () => (includeDeleted ? rows : rows.filter((r) => !r.deletedAt)),
    [rows, includeDeleted]
  )
}
